<template>
  <div>
    <!--begin::Content header-->
    
    <!--end::Content header-->
      <!--begin::Form-->
      <b-form class="form-signin d-flex align-items-stretch flex-column" @submit.stop.prevent="onSubmit">
        <div class="text-center mb-2">
          <img class="mb-2" src="media/img/femsa.png" alt="" width="120">
          <h3 class="mb-0">Recuperar Contraseña</h3>
        <span> </span>
        </div>
        <div class="alert alert-danger" v-show="!step2">
          <div class="alert-text">
            Su cuenta se encuentra bloqueada por cantidad de intentos fallidos. Puedes solicitar una nueva contraseña. 
          </div>
        </div>
        <div 
          role="alert" v-show="errors.length>0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
        <div class="form-label-group" v-show="!step2">
          <label for="rutEmpresa">Rut Empresa</label>
          {{$v.form.rutEmpresa.$model}}
          <b-form-input
             class="form-control"
            id="rutEmpresa"
            name="rutEmpresa"
            v-model="$v.form.rutEmpresa.$model"
            :state="validateState('rutEmpresa')"
            aria-describedby="rutEmpresa-mensaje-validacion"
            placeholder="Rut Empresa"
          ></b-form-input>
          <b-form-invalid-feedback id="rutEmpresa-mensaje-validacion">Rut de empresa es obligatorio y debe ser válido</b-form-invalid-feedback>
        </div>
        <div class="form-label-group" v-show="!step2">
          <label for="inputRut">Rut</label>
          <b-form-input
             class="form-control"
            id="rut"
            name="rut"
            v-model="$v.form.rut.$model"
            :state="validateState('rut')"
            aria-describedby="rut-mensaje-validacion"
            placeholder="Rut"
          ></b-form-input>
          <b-form-invalid-feedback id="rut-mensaje-validacion">Rut es obligatorio y debe ser válido</b-form-invalid-feedback>
        </div>
        <!--begin::Action-->
         <button  v-show="!step2"
            type="submit"
            ref="kt_login_signup_submit"
             class="btn btn-primary align-self-center"
          >Enviar Correo</button>
        <b-alert show v-show="step2" variant="success">Si tus datos son correctos, hemos enviado un correo electrónico con instrucciones para reestablecer tu contraseña.</b-alert>
        <p class="mt-3 mb-3 text-muted text-center">
          <router-link
            class="text-dark-60 text-hover-primary my-3 mr-2"
            :to="{name:'login'}"
            id="kt_login_forgot"
          >
           Volver
          </router-link>
        </p>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
</style>

<script>
import { mapState } from "vuex";
import {rutEsValido} from "@/core/validators/rut.js"
import { RECOVERY_PASSWORD } from "@/core/services/store/client.module";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "recuperarContrasena",
  data() {
    return {
      step2:false,
      // Remove this dummy login info
      form: {
          rut: "",
          rutEmpresa:""
      },
    }
  },
  validations: {
    form: {
      rut: {
        required,
        rutEsValido
      },
      rutEmpresa: {
        required,
        rutEsValido
      }
    }
  },
  methods: {
    makeToast(append = false) {
      this.$bvToast.toast(`Hemos validado correctamente la información.
          Ahora completa tu nombre, apellido y email para darte de alta.`, {
        title: 'Te hemos validado',
        autoHideDelay: 5000,
        variant: "success",
        toaster:"b-toaster-top-right",
        appendToast: append
      })
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        rut: null,
        rutEmpresa:null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const rut = this.$v.form.rut.$model;
      const rutEmpresa = this.$v.form.rutEmpresa.$model;
      const submitButton = this.$refs["kt_login_signup_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(RECOVERY_PASSWORD, {rut, rutEmpresa})
          // go to which page after successfully login
          .then(() => this.step2 = true/*, this.$router.push({ name: "login" })*/);

        /*submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );*/
      }, 500);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
